module.exports = __webpack_public_path__ + "img/ihrm3.8a89f4f4.png";